export default "__VITE_ASSET__UwF30S9M__"